import { z } from 'zod';
import {
  DEFAULT_ARTICLE_VIEWS,
  DENSITIES,
  READING_SIZES,
  READING_WIDTHS,
  SORT_ORDERS,
  THEME_SETTINGS,
  VIEW_MODES,
} from '../types.js';

export const settingsSchema = z.object({
  theme: z.enum(THEME_SETTINGS),
  density: z.enum(DENSITIES),
  defaultViewMode: z.enum(VIEW_MODES),
  /** Article order for All items and every feed or folder with none saved (#31). */
  defaultSortOrder: z.enum(SORT_ORDERS),
  defaultArticleView: z.enum(DEFAULT_ARTICLE_VIEWS),
  markReadOnScroll: z.boolean(),
  /** Mark an article read when it opens (true), or only by hand (#24). */
  markReadOnOpen: z.boolean(),
  showUnreadOnly: z.boolean(),
  /** Article text size and line width in the reading pane (#41). */
  readingSize: z.enum(READING_SIZES),
  readingWidth: z.enum(READING_WIDTHS),
});
export type Settings = z.infer<typeof settingsSchema>;

/** PUT /settings accepts only the changed fields. */
export const updateSettingsSchema = settingsSchema.partial();
export type UpdateSettingsInput = z.infer<typeof updateSettingsSchema>;

/**
 * The single source of truth for defaults. Must equal the DB column defaults on
 * user_settings and what GET /settings returns when no row exists.
 */
export const DEFAULT_SETTINGS: Settings = {
  theme: 'auto',
  density: 'comfortable',
  defaultViewMode: 'cards',
  defaultSortOrder: 'newest',
  defaultArticleView: 'auto',
  markReadOnScroll: false,
  markReadOnOpen: true,
  showUnreadOnly: false,
  readingSize: 'medium',
  readingWidth: 'normal',
};
